"use client";

import ImageSwiperSection from "@/components/ImageSwiperSection/ImageSwiperSection";
import "./ProductDesignSection.scss";

const ProductDesignSection = ({ product }) => {
  const { title, subtitle, features } = product;

  return (
    <ImageSwiperSection
      title={title}
      description={subtitle}
      items={features}
      sectionClass="product-design-section"
      titleClass="product-design-title"
      descriptionClass="product-design-description"
    />
  );
};

export default ProductDesignSection;
